import { AuctionDTO } from 'models'
import { UniversalAuctionDetail } from 'models/universalData'
import React from 'react'

type FutureSaleVehiclesContextProps = {
  vehicles: Array<UniversalAuctionDetail>
  isModificationRestricted: boolean
  modificationMessage: string
}

const defaultfutureSaleVehiclesContextProps: FutureSaleVehiclesContextProps = {
  vehicles: [],
  isModificationRestricted: true,
  modificationMessage: '',
}
// TODO: Delete?
const FutureSaleVehiclesContext = React.createContext<FutureSaleVehiclesContextProps>(
  defaultfutureSaleVehiclesContextProps,
)

const useFutureSaleVehicles = () => React.useContext(FutureSaleVehiclesContext)

export { FutureSaleVehiclesContext, useFutureSaleVehicles }
export type { FutureSaleVehiclesContextProps }
